import { toPlainText } from './profileMarkup';

// Profiles with more words than this in the summary or experience prompt the user to summarise.
export const LONG_TEXT_WORD_LIMIT = 200;

export const countWords = (text) => {
  if (typeof text !== 'string') {
    return 0;
  }
  return text.split(/\s+/).filter(Boolean).length;
};

// Formatting markup (# - ** *) is not counted.
export const exceedsWordLimit = (text, limit = LONG_TEXT_WORD_LIMIT) => countWords(toPlainText(text)) > limit;
